import { Reveal, Eyebrow } from "./primitives";
import { STATS } from "@/lib/content";

export default function Statistics() {
  return (
    <section id="statistics" data-testid="statistics-section" className="bg-bone py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal>
            <Eyebrow>{STATS.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl font-medium leading-tight tracking-tight text-ink sm:text-5xl">
              {STATS.heading}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-stone sm:text-lg">{STATS.intro}</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.stats.map((s, i) => (
            <Reveal key={i} delay={(i % 4) * 0.06} data-testid={`stat-card-${i}`}>
              <div className="flex h-full flex-col rounded-3xl bg-sand p-7 transition-transform duration-500 hover:-translate-y-1">
                <p className="font-serif text-5xl font-medium tracking-tight text-terracotta sm:text-6xl">
                  {s.value}
                </p>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-stone">{s.label}</p>
                <p className="mt-5 border-t border-line pt-4 text-xs font-semibold uppercase tracking-[0.12em] text-sage">
                  {s.source}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
